<template>
    <v-container fluid>
        <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
        >
            <v-row>
                <v-col 
                    style="display: flex; align-content: center; align-items: center;"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <h3>To Do Manager</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <hr />
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    lg="3"
                    md="3"
                    sm="12"
                >
                    <label>Period</label>
                    <v-combobox
                        v-model="toDoManagerRequest.typeToDoSelected"
                        :items="listPeriod"
                        :rules=[validations.required]
                        item-text="description"
                        item-value="id"
                        clearable
                        single-line
                        outlined
                        dense
                    ></v-combobox>
                </v-col>
                <v-col 
                    cols="12"
                    lg="3"
                    md="3"
                    sm="12"
                >
                    <label>Type</label>
                    <v-combobox
                        v-model="toDoManagerRequest.typeSelected"
                        :items="listType"
                        :rules=[validations.required]
                        item-text="description"
                        item-value="id"
                        clearable
                        single-line
                        outlined
                        dense
                    ></v-combobox>
                </v-col>
                <v-col 
                    cols="12"
                    lg="3"
                    md="3"
                    sm="12"
                >
                    <v-menu
                        ref="mnuDateStart"
                        v-model="mnuDateStart"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <label>Start Date</label>
                            <v-text-field
                                v-model="dateStartFormatted"
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                :rules="[validations.required]" 
                                @blur="dateStart = parseDate(dateStartFormatted)"
                                outlined
                                single-line
                                v-on="on"
                                dense
                                clearable
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateStart"
                            no-title
                            @input="mnuDateStart = false"
                            :min="today"
                            color="primary lighten-1"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col 
                    cols="12"
                    lg="3"
                    md="3"
                    sm="12"
                >
                    <v-menu
                        ref="mnuDateEnd"
                        v-model="mnuDateEnd"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <label>End Date</label>
                            <v-text-field
                                v-model="dateEndFormatted"
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                @blur="dateEnd = parseDate(dateEndFormatted)"
                                outlined
                                single-line
                                v-on="on"
                                dense
                                clearable
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateEnd"
                            no-title
                            @input="mnuDateEnd = false"
                            :min="dateStart"
                            color="primary lighten-1"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                >
                    <label>Profile</label>
                    <v-combobox
                        v-model="toDoManagerRequest.profileSelected"
                        :items="listProfile"
                        :rules=[validations.required]
                        item-text="name"
                        item-value="id"
                        clearable
                        single-line
                        outlined
                        @change="filterUser(); toDoManagerRequest.userSelected = null"
                        dense
                    ></v-combobox>
                </v-col>
                <v-col 
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                >
                    <label>User</label>
                    <v-combobox
                        v-model="toDoManagerRequest.userSelected"
                        :items="listUser"
                        item-text="name"
                        item-value="id"
                        clearable
                        single-line
                        outlined
                        dense
                    ></v-combobox>
                </v-col>
            </v-row>
            <v-row>
                <v-col 
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <label>Title</label>
                    <v-text-field
                        v-model="toDoManagerRequest.title" 
                        :rules=[validations.required]
                        single-line
                        outlined
                        dense
                    >
                    </v-text-field>
                </v-col>
                <v-col 
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <label>Description</label>
                    <v-textarea
                        v-model="toDoManagerRequest.description"
                        :rules=[validations.required]
                        single-line
                        rows="4"
                        row-height="30"
                        outlined
                    >
                    </v-textarea>
                </v-col>
            </v-row>

            <br />

            <ActionButtons
                :request="toDoManagerRequest"
                :loading="loading"
                :showButtons="{
                    cancel: true,
                    save: true
                }"
                @cancel="cancel"
                @save="save"
            />
        </v-form>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from "@/utilities/Rules";
    import Helpers from '@/utilities/Helpers';
    import ActionButtons from "@/components/Layout/ActionButtons";

    export default ({

        mixins: [Helpers],

        components: {
            ActionButtons
        },

        data: vm => ({

            validForm: true,

            toDoManagerRequest: {
                id: 0,
                typeToDoSelected: null,
                typeToDo: null,
                typeSelected: null,
                type: null,
                dateStart: null,
                dateEnd: null,
                profileSelected: null,
                idProfile: 0,
                userSelected: null,
                idUser: "0",
                title: "",
                description: ""
            },
            today: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

            dateStart: vm.today,
            dateStartFormatted: vm.formatDate(vm.today),
            mnuDateStart: false,

            dateEnd: vm.today,
            dateEndFormatted: vm.formatDate(vm.today),
            mnuDateEnd: false,

            listUser: [],
            listUserClone: [],
            listProfile: [],
            listPeriod: [
                { id: 1, description: 'Daily' },
                { id: 2, description: 'Weekly' },
                { id: 3, description: 'Monthly' },
            ],
            listType: [
                { id: 1, description: 'Urgent' },
                { id: 2, description: 'Information' },
            ],
            
            loading: false,

            validations: {
                required: required,
            }
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' })
        },

        watch: {
            dateStart () {
                this.dateStartFormatted = this.formatDate(this.dateStart)
            },

            dateEnd () {
                this.dateEndFormatted = this.formatDate(this.dateEnd)
            },
        },

        props: {
            id: {
                default: 0
            }
        },

        methods: {

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            
            async getRegister() {
                if (this.id != 0) {

                    const response = await this.$store.dispatch("toDoManagerModule/GetById", this.id);
                    this.toDoManagerRequest = response.result;

                    this.dateStartFormatted = this.toDoManagerRequest.dateStartFormatted;
                    this.dateStart = this.parseDate(this.toDoManagerRequest.dateStartFormatted);
                    this.dateEndFormatted = this.toDoManagerRequest.dateEndFormatted;
                    this.dateEnd = this.parseDate(this.toDoManagerRequest.dateEndFormatted);
                    
                    this.toDoManagerRequest.typeToDoSelected = this.listPeriod.filter(item => item.id == this.toDoManagerRequest.typeToDo)[0];
                    this.toDoManagerRequest.typeSelected = this.listType.filter(item => item.id == this.toDoManagerRequest.type)[0];
                }
            },

            async filterUser () {

                this.showLoading();

                if (this.toDoManagerRequest.profileSelected != null && this.toDoManagerRequest.profileSelected != undefined) {
                    this.toDoManagerRequest.idProfile = this.toDoManagerRequest.profileSelected.id;
                    this.listUser = this.listUserClone.filter(usr => usr.idProfile == this.toDoManagerRequest.idProfile)
                }

                if (this.toDoManagerRequest.userResponsibleSelected != null && this.toDoManagerRequest.userResponsibleSelected != undefined) {
                    this.toDoManagerRequest.idUser = this.toDoManagerRequest.userResponsibleSelected.id
                }

                this.hideLoading();
            },

            async loadProfilesAndUsers() {
                
                this.listProfile = await this.$store.dispatch("profileModule/List");
                let listUser = await this.$store.dispatch("userModule/List");
                let idProfileSelected = 0;

                if (this.toDoManagerRequest.profileSelected != null && 
                    this.toDoManagerRequest.profileSelected != undefined && 
                    this.toDoManagerRequest.profileSelected.id != 0) {
                    idProfileSelected = this.toDoManagerRequest.profileSelected.id;

                    listUser = listUser.filter(usr => usr.idProfile == idProfileSelected);
                }

                this.listUser = [...listUser];
                this.listUserClone = [...listUser];

                if (this.userLoggedGetters.listIDUsers != null && 
                    this.userLoggedGetters.listIDUsers != undefined &&
                    this.userLoggedGetters.listIDUsers.toString().trim() != '') {
                    const listIDUsers = this.userLoggedGetters.listIDUsers.toString().split(';');

                    let newListUsers = [];

                    listIDUsers.forEach(idUser => {

                        if (idUser != null && idUser != undefined && idUser.toString().trim() != '') {
                            const userFiltered = listUser.filter(item => item.id.toString() == idUser)[0];

                            if (userFiltered && userFiltered != null && userFiltered != undefined) {
                                newListUsers.push(userFiltered);
                                this.listUser = newListUsers;
                            }
                        }
                    });
                }
            },

            async cancel() {
                this.$router.push({ path: "/toDoManager/toDoManagerList" });
            },

            async save() {

                await this.$refs.form.validate();

                if (this.validForm === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the form. Please review!");
                    return false;
                }
                else {
                    this.loading = true;
                    this.showLoading();

                    this.toDoManagerRequest.id = this.id;

                    if (this.toDoManagerRequest.typeToDoSelected != null && this.toDoManagerRequest.typeToDoSelected != undefined) {
                        this.toDoManagerRequest.typeToDo = this.toDoManagerRequest.typeToDoSelected.id;
                    }

                    if (this.toDoManagerRequest.typeSelected != null && this.toDoManagerRequest.typeSelected != undefined) {
                        this.toDoManagerRequest.type = this.toDoManagerRequest.typeSelected.id;
                    }

                    if (this.toDoManagerRequest.profileSelected != null && this.toDoManagerRequest.profileSelected != undefined) {
                        this.toDoManagerRequest.idProfile = this.toDoManagerRequest.profileSelected.id;
                    }

                    if (this.toDoManagerRequest.userSelected != null && this.toDoManagerRequest.userSelected != undefined) {
                        this.toDoManagerRequest.idUser = this.toDoManagerRequest.userSelected.id;
                    }
                    
                    this.toDoManagerRequest.dateStart = this.dateStart == "" ? null : this.dateStart ;
                    this.toDoManagerRequest.dateEnd = this.dateEnd == "" ? null : this.dateEnd ;

                    const result = await this.$store.dispatch("toDoManagerModule/CreateUpdate", this.toDoManagerRequest);

                    if (result.success === true) {
                        this.showToast("success", "Success!", result.message);
                        this.cancel();
                    }
                    else {
                        this.showToast("error", "Warning!", result.message);
                    }

                    this.loading = false;
                    this.hideLoading();
                }
            }
        },

        async created() {
            this.showLoading();

            await this.loadProfilesAndUsers();
            await this.filterUser();
            this.getRegister();

            this.hideLoading();
        }
    })
</script>
